var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('CallMe',{attrs:{"companyphone":_vm.phone,"lang":_vm.lang},on:{"close":_vm.handleModalView}}):_vm._e()],1),_vm._v(" "),_c('StickyContact',{attrs:{"lang":_vm.lang},on:{"open":_vm.handleModalView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./assets/_js/components/CtaContainer/CtaContainer.vue?vue&type=template&id=44e1ffec&
// module id = 332
// module chunks = 0